export default `mutation viewidePlaceOrder($input: viewidePlaceOrderInput) {
  viewidePlaceOrder(input: $input) {
    order {
      order_id
    }
  }
 }
`
